import ReactDom from 'react-dom';

import './components/Zipy';
import Root from './App';

const mountOn = 'root';

const mountElem = document.getElementById(mountOn);

const Entry = () => <Root enableDatadog={true} />;
ReactDom.render(<Entry />, mountElem);
